import React from "react";
import "./IntroExpert.scss";
import imgBg from "../images/introbackground.png";
import imgApp from "../images/introapp.png";
import imgBgAvif from "../images/introbackground.avif";
import imgAppAvif from "../images/introapp.avif";
import imgRussiaflag from "../images/russiaflag.png";
import backgroundApp from '../images/backgroundApp.png'
import backgroundAppAvif from '../images/backgroundApp.avif'
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";

function Intro() {
  const renderTitle = () => {
    return (
      <>
        <div
          className="page-title mb-4"
          style={{ fontSize: "50px", fontWeight: "bold" }}
        >
          <TitleAccent className="mb-3">SCADA NPT</TitleAccent>
          <TitleAccent className="mb-3">Expert</TitleAccent>
        </div>
      </>
    );
  };
  const renderDecription = () => {
    return (
      <div
        className="page-description"
        style={{ fontSize: "24px", fontWeight: "normal", letterSpacing: "2px" }}
      >
        <div>
          Простое <ColorAccent>управление</ColorAccent>
        </div>
        <div>
          <ColorAccent>сложными</ColorAccent> процессами
        </div>
      </div>
    );
  };
  const renderBrands = () => {
    return (
      <div className="d-flex intro__brands">
        <div
          style={{
            whiteSpace: "nowrap",

            letterSpacing: "1px",
            color: "#00000090",
            marginRight: "2rem",
          }}
          className="d-flex "
        >
          <div style={{ marginRight: ".5rem" }}>
            <div>Сделано в</div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "calc(var(--brands-font-size) * 1.5)",
                lineHeight: "calc(var(--brands-font-size) * 1.5)",
              }}
            >
              России
            </div>
          </div>
          <div>
            <img src={imgRussiaflag} />
          </div>
        </div>
        <MinDigitsBrand id="304990" />

      </div>
    );
  };
  return (
    <>
      {/* <img
        src={imgBg}
        className="position-absolute intro__bg"
        style={{
          width: "100%",
          objectFit: "cover",
          height: "100%",
          padding: "0",
        }}
      ></img> */}
      {/* <img
        src={backgroundApp}
        className="position-absolute intro__bg-mobile"
        style={{
          width: "100%",
          objectFit: "cover",
          height: "100%",
          padding: "0",

        }}
      ></img> */}
      <picture
        style={{
          width: "100%",
          objectFit: "cover",
          height: "100%",
          padding: "0",

        }}
      >
        <source srcSet={backgroundAppAvif} media="(max-width: 1000px)" type="image/avif" />
        <source srcSet={imgBgAvif} type="image/avif" />
        <img
          src={imgBg}
          className="position-absolute "
          style={{ width: '100%', objectFit: 'cover', height: '100%', padding: '0' }}
        ></img>
      </picture>
      <Content className="d-flex   intro__content">

        <div
          style={{
            zIndex: 1,
            width: "50%",
            paddingTop: "2rem",
            paddingLeft: "0",
          }}
          className="d-flex flex-column  h-100 position-relative intro__data"
        >
          {renderTitle()}
          {renderDecription()}

          {renderBrands()}
        </div>
        <div
          style={{ zIndex: 1, width: "50%" }}
          className="d-flex align-items-center  h-100 position-relative intro__image"
        >
          {/* <img
            src={imgApp}
            style={{ width: "130%", padding: "0", position: "absolute" }}
          ></img> */}
          <picture style={{ width: "150%", padding: "0" }}>


            {/* <source
              media="(min-width: 741px)"
              srcSet={imgAppAvif}
              type="image/avif" />
            <source
              media="(min-width: 741px)"
              srcSet={imgApp} /> */}

            <img
              src={imgApp}
              alt=""

              loading="eager"
              style={{ width: '160%', padding: '0', }}
            />
          </picture>
        </div>

      </Content>
    </>
  );
}

const ColorAccent = ({ children }) => {
  return (
    <span style={{ fontWeight: "bold" }} className="text-danger ">
      {children}
    </span>
  );
};
const TitleAccent = ({ className, children }) => {
  return (
    <div
      style={{
        paddingRight: "2rem",
        paddingLeft: ".5rem",
        clipPath: "polygon(0 1%, 100% 0, 90% 100%, 0% 100%)",
        background: "var(--red)",
        width: "max-content",
        color: "white",
      }}
      className={className}
    >
      {children}
    </div>
  );
};
const Content = ({ children, className }) => {
  return (
    <div
      className={className}
      style={{

      }}
    >
      {children}
    </div>
  );
};
export default Intro;
